module.exports = __webpack_public_path__ + "static/media/analytics.19779204.svg";